import { LoaderCircle } from "lucide-react";

const FullScreenLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(255, 255, 255, 0.55)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 9999,
      }}
    >
      <LoaderCircle
        size={52}
        color="#2563eb"
        style={{
          animation: "spin 1s linear infinite",
        }}
      />

      <h2
        style={{
          marginTop: "20px",
          fontSize: "20px",
          fontWeight: 600,
          color: "#1f2937",
        }}
      >
        Changing language...
      </h2>

      <p
        style={{
          marginTop: "8px",
          fontSize: "14px",
          color: "#6b7280",
        }}
      >
        Loading translations...
      </p>

      <style>
        {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default FullScreenLoader;